// src/components/ui/CreateTeamDialog.tsx
import { Dialog, DialogContent, DialogTitle } from "./dialog";
import { Button } from "./button";
import { useState } from "react";

export function CreateTeamDialog({ open, onOpenChange, onSubmit }: any) {
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [state, setStateVal] = useState("");
  const [country, setCountry] = useState("");
  const [info, setInfo] = useState("");

  const handleSubmit = () => {
    if (!name.trim()) return alert("Team name required");

    onSubmit({
      name,
      city,
      state,
      country,
      info,
      profile_image: "",
      cover_image: "",
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md space-y-4">
        <DialogTitle>Create New Team</DialogTitle>

        <input
          className="w-full border p-2 rounded-md"
          placeholder="Team Name"
          value={name}
          min={50}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          className="w-full border p-2 rounded-md"
          placeholder="City"
          value={city}
          min={50}
          onChange={(e) => setCity(e.target.value)}
        />

        <input
          className="w-full border p-2 rounded-md"
          placeholder="State"
          value={state}
          min={50}
          onChange={(e) => setStateVal(e.target.value)}
        />

        <input
          className="w-full border p-2 rounded-md"
          placeholder="Country"
          value={country}
          min={50}
          onChange={(e) => setCountry(e.target.value)}
        />

        <textarea
          className="w-full border p-2 rounded-md resize-none"
          placeholder="Team Info"
          value={info}
          maxLength={2000}
          onChange={(e) => setInfo(e.target.value)}
        />

        <Button className="w-full" onClick={handleSubmit}>
          Create Team
        </Button>
      </DialogContent>
    </Dialog>
  );
}
